import "../css/style.css";

// const images = [
//     "../image/slideshow/jepang.JPG",
//     "../image/slideshow/bali.JPG",
//     "../image/slideshow/thailand.JPG",
//     "../image/slideshow/china.JPG",
//     "../image/slideshow/paris.JPG",
//     "../image/slideshow/dubai.JPG",
// ];

function PromoPage() {
    // const [currentIndex, setCurrentIndex] = useState(0);

    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         setCurrentIndex((prev) => (prev + 1) % images.length);
    //     }, 5000);

    //     return () => clearInterval(timer);
    // }, []);

    return (
        <section className="px-6 py-10 max-w-7xl mx-auto">
            <h2 className="text-xl font-bold mb-4">Why Wait? Check the Promo Now</h2>

            {/* Tabs */}
            <div className="flex justify-left gap-3 mb-6">
                {["Flights", "Hotels", "Travel Packages"].map((tab, idx) => (
                    <button
                        key={tab}
                        className={`px-4 py-2 rounded-full shadow-sm font-medium ${idx === 0 ? "bg-sky-500 text-white" : "bg-gray-100 text-gray-600"
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* Promo Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                {["bg-pink-100", "bg-yellow-100", "bg-blue-100", "bg-blue-100"].map((color, idx) => (
                    <div key={idx} className={`${color} p-6 rounded-xl shadow-md`}>
                        <div className="text-left">
                            <p className="font-semibold flex items-center gap-2">
                                🌍 Explore the World
                            </p>
                            <p className="text-xl font-bold mt-2">Up to 60% Off!</p>
                        </div>
                    </div>
                ))}
            </div>

            {/* See All Promo Button */}

            <div className="mt-8 flex justify-center">
                <button className="bg-sky-100 text-sky-600 px-6 py-2 rounded-full font-medium shadow-sm hover:bg-sky-200 ">
                    See All Promo
                </button>


            </div>
        </section>
    );
}

export default PromoPage;
